import { useTranslation } from 'react-i18next'

import { Check } from 'lucide-react'

import { seoKeywordI18nPrefix } from './catalog'

const POINT_KEYS = ['1', '2', '3', '4', '5'] as const

export function ParaQuienEsAudienceSection() {
    const { t } = useTranslation()
    const prefix = seoKeywordI18nPrefix('para-quien-es')

    return (
        <section className='bg-white px-[22px] py-14 md:px-10 md:py-20'>
            <div className='mx-auto flex max-w-[720px] flex-col gap-6'>
                <div className='flex flex-col gap-2.5'>
                    <h2 className='m-0 text-[32px] font-medium leading-[1.15] tracking-[-1px] text-[#F4502A] md:text-[46px]'>
                        {t(`${prefix}.audience.title`)}
                    </h2>
                    <p className='m-0 text-[18px] font-medium leading-snug text-[#17130E] md:text-[20px] md:leading-snug'>
                        {t(`${prefix}.audience.answerCapsule`)}
                    </p>
                </div>

                <div className='flex flex-col gap-4'>
                    <p className='m-0 text-[15px] leading-relaxed text-[#5C5548] md:text-[17px] md:leading-[1.7]'>
                        {t(`${prefix}.audience.description1`)}
                    </p>
                    <p className='m-0 text-[15px] leading-relaxed text-[#5C5548] md:text-[17px] md:leading-[1.7]'>
                        {t(`${prefix}.audience.description2`)}
                    </p>
                </div>

                <ul className='m-0 flex list-none flex-col p-0'>
                    {POINT_KEYS.map(pointKey => (
                        <li
                            key={pointKey}
                            className='flex items-start gap-3 border-t border-[#E8E1D5] py-[18px] last:border-b'
                        >
                            <Check
                                className='mt-0.5 h-[18px] w-[18px] shrink-0 text-[#F4502A]'
                                strokeWidth={2.75}
                                aria-hidden
                            />
                            <span className='text-[15px] font-medium leading-snug text-[#17130E] md:text-base'>
                                {t(`${prefix}.audience.points.${pointKey}`)}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
